import React from 'react';
import TermsAndConditions from './TermsAndConditions';

const TermsModal = ({ isOpen, onClose, onAccept }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
        ></div>

        {/* Modal content */}
        <div className="inline-block w-full max-w-3xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg">
          <div className="bg-white px-6 py-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-medium text-gray-900">
                Terms and Conditions
              </h3>
            </div>
            
            <TermsAndConditions 
              onAccept={onAccept} 
              isModal={true} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;